<template>
    <div class="mt-4 text-center lg:mt-8 lg:flex lg:items-center lg:justify-between">
        <div class="text-sm font-medium leading-6 lg:leading-none">
            &copy; {{ currentYear }}
            <a href="https://sinaubumi.org/" target="_blank">
                Sinau Bumi
            </a>
            &
            <a href="https://www.ipb.ac.id/" target="_blank">
                IPB University
            </a>
        </div>
        <div class="mt-2 flex items-center justify-center gap-4 lg:mt-0">
            <span class="text-sm font-normal">Versi 1.4.6</span>
        </div>
    </div>
</template>
<script>
import { Link } from "@inertiajs/vue3";
export default {
    components: {
        Link,
    },
    data() {
        return {
            currentYear: new Date().getFullYear()
        };
    },
};
</script>